if (!customElements.get('product-share')) {
  customElements.define(
    'product-share',
    class ProductShare extends HTMLElement {
      constructor() {
        super();

        this.url = this.dataset.url;
        this.title = this.dataset.title;
        this.toggle = this.querySelector('.product-share__toggle');
        this.panel = this.querySelector('.product-share__panel');
        this.copyButton = this.querySelector('.product-share__copy');
        this.copyLabel = this.querySelector('.product-share__copy-label');
        this.instagramLink = this.querySelector('.product-share__instagram');

        this.toggle.addEventListener('click', this.onToggleClick.bind(this));
        this.copyButton.addEventListener('click', this.onCopyClick.bind(this));

        if (this.instagramLink) {
          this.instagramLink.addEventListener('click', this.onInstagramClick.bind(this));
        }

        document.addEventListener('click', this.onDocumentClick.bind(this));
      }

      onToggleClick(event) {
        event.stopPropagation();

        if (navigator.share) {
          navigator.share({ url: this.url, title: this.title }).catch(() => {});
          return;
        }

        const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
        this.toggle.setAttribute('aria-expanded', String(!expanded));
        this.panel.classList.toggle('hidden', expanded);
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) {
          this.close();
        }
      }

      close() {
        this.toggle.setAttribute('aria-expanded', 'false');
        this.panel.classList.add('hidden');
      }

      onCopyClick() {
        navigator.clipboard.writeText(this.url).then(() => {
          const original = this.copyLabel.textContent;
          this.copyLabel.textContent = window.accessibilityStrings ? window.accessibilityStrings.shareSuccess : 'Copied!';
          setTimeout(() => {
            this.copyLabel.textContent = original;
          }, 2000);
        });
      }

      onInstagramClick() {
        // Instagram has no public web share-intent that accepts a prefilled link,
        // so copy the link for the user to paste into their Story/DM/bio.
        navigator.clipboard.writeText(this.url).catch(() => {});
      }
    }
  );
}
